import React from 'react';
import { brandByKey, brands, criteria } from '../../data/strategy';
import { BrandLegend } from '../deck/BrandLegend';
import { PerceptionChart, type ChartRow } from '../deck/PerceptionChart';
import { SlideFrame, SlideTitle } from '../deck/SlideFrame';
const rows: ChartRow[] = criteria.map(criterion => ({
  label: criterion.label,
  points: brands.map(brand => ({
    key: brandByKey[brand.key].name,
    value: criterion.leo[brand.key],
    color: brand.color
  }))
}));
export function LeoFactsSlide() {
  return <SlideFrame marker="Step 03 — Our fact base" data-id="element-126" data-mp="2yr7eloj10aje">
      <SlideTitle sub="Agreed in a single session with medical, market access and brand. One rule: if we cannot put evidence behind it in front of a sceptical prescriber, it does not go on the chart." data-id="element-127" data-mp="33ph9rz4r3b50">
        What LEO holds to be true
      </SlideTitle>

      <div className="mt-[3vh] flex min-h-0 flex-1 gap-[4%]" data-id="element-128" data-mp="2b0ab905aqljr">
        <div className="min-h-0 flex-1 pb-[1vh]" data-id="element-129" data-mp="2fzegxgt0i15c">
          <PerceptionChart rows={rows} axisLabel="Defensible strength (1 = weaker → 5 = stronger)" highlightKey="ENSTILAR®" labelWidth="26%" data-id="element-130" data-mp="2fy3dji3haver" />
        </div>
        <aside className="flex w-[26%] flex-col justify-center gap-[2.4vh] border-l border-ink-line pl-[4%]" data-id="element-131" data-mp="1lqxvskmxk827">
          <div data-id="element-132" data-mp="1bys318outmly">
            <p className="text-[clamp(9px,1vw,16px)] font-semibold uppercase tracking-[0.12em] text-brand-enstilar" data-id="element-133" data-mp="1bzaal1gyvn96">
              Our position
            </p>
            <p className="mt-[1vh] text-[clamp(11px,1.22vw,20px)] leading-[1.45] text-ink-soft" data-id="element-134" data-mp="16xkwte2d0vhe">
              Clear lead on efficacy, speed and patient experience — and an
              honest parity on safety.
            </p>
          </div>
          <div data-id="element-135" data-mp="t0fwzvt8osul">
            <p className="text-[clamp(9px,1vw,16px)] font-semibold uppercase tracking-[0.12em] text-ink-mute" data-id="element-136" data-mp="t0xyb6urdx9d">
              The discipline
            </p>
            <p className="mt-[1vh] text-[clamp(11px,1.22vw,20px)] leading-[1.45] text-ink-soft" data-id="element-137" data-mp="2ndxizedzxhni">
              We rate competitors here too. Overstating our own case only
              manufactures a gap we cannot close.
            </p>
          </div>
        </aside>
      </div>

      <BrandLegend variant="bar" className="mt-[2.4vh] shrink-0" data-id="element-138" data-mp="3bbdf4bz30wzx" />
    </SlideFrame>;
}